import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddEditEventPage from "../../components/Events/AddEditEventPage";

const AddEditEvent = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Curiouzz Social" />
        <AddEditEventPage />
      </MasterLayout>
    </>
  );
};

export default AddEditEvent;
